import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockType } from '../../@types/BlockType';

export class RandomColorAttribute extends AbstractBlock {
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);
    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const inner_attr = CodeSetting.buildAttribute([[this.name_for_code, '']], attribute);
    return [inner_attr];
  }
}
